// extracted by mini-css-extract-plugin
module.exports = {"faceStack":"HeadlineWrapper_faceStack__LQNDQ","mobile":"HeadlineWrapper_mobile__qzUCx","desktop":"HeadlineWrapper_desktop___Aeh9"};